/* Angular modules */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
/* app modules */
import {LoggerService} from '../logging/logger.service';
import {
  AssociateOptionCategoryPayload,
  AssociateOptionPayload, CategoryOrderUpdatePayload,
  CopyOptionPayload, CopyOptionResponsePayload,
  CubicleOption, EditCategoryNamePayload, EditOptionPayload,
  EditOptionValuePayload,
  GetOptionsByCategoryPayload,
  GetOptionsPayload, OptionOrderUpdatePayload
} from '../model/cubicleOption-model';
import {TranslationPayload} from "../model/translation-payload";
import {SwitchBoardComponent} from "../../configuration/shared/model/component";

@Injectable()
export class OptionsService {

  constructor(private httpClient: HttpClient,
              private logger: LoggerService) {
  }

  getOptionsByRangeId(rangeId, forceUpdate: boolean = false): Observable<GetOptionsPayload> {
    this.logger.debug('OptionsService getOptionsByRangeId()');
    return this.httpClient.cache(forceUpdate).get<GetOptionsPayload>('/options/references/' + rangeId );
  }

  getOptionsByComponentId(componentId: string): Observable<GetOptionsByCategoryPayload> {
    this.logger.debug('OptionsService getOptionsByComponentId()');
    return this.httpClient.get<GetOptionsByCategoryPayload>('/options/component/' + componentId);
  }


  getOptionsElementsByRangeId(rangeId, forceUpdate: boolean = false): Observable<CubicleOption[]> {
    this.logger.debug('OptionsService getOptionsElementsByRangeId()');
    return this.httpClient.get<CubicleOption[]>('/options/' + rangeId );
  }

  createOption(editOptionForm: EditOptionPayload): Observable<GetOptionsPayload> {
    return this.httpClient.post<GetOptionsPayload>('/options', editOptionForm);
  }

  editOption(editOptionForm: EditOptionPayload): Observable<GetOptionsPayload> {
    return this.httpClient.put<GetOptionsPayload>('/options', editOptionForm);
  }

  editCategoryName(editOptionForm: EditCategoryNamePayload): Observable<any> {
    return this.httpClient.put<any>('/options/category/name', editOptionForm);
  }

  copyOption(copyOptionPayload: CopyOptionPayload): Observable<CopyOptionResponsePayload> {
    return this.httpClient.put<CopyOptionResponsePayload>('/options/copy', copyOptionPayload);
  }

  deleteOptionElement(  id: string): Observable<any> {
    return this.httpClient.delete<any>('/options/'+  id, {});
  }

  addOptionValue(addOptionValueForm: EditOptionValuePayload) : Observable<GetOptionsPayload> {
    return this.httpClient.post<GetOptionsPayload>('/options/value', addOptionValueForm);
  }

  editOptionValue(addOptionValueForm: EditOptionValuePayload) : Observable<GetOptionsPayload> {
    return this.httpClient.put<GetOptionsPayload>('/options/value', addOptionValueForm);
  }

  deleteOptionValueElement(optionName: string, valueName: string): Observable<any> {
    return this.httpClient.delete<any>('/options/'+ optionName + '/' + valueName,  {});
  }
  getOptionDescriptionTranslations(rangeId: string, reference: string): Observable<TranslationPayload[]> {
    return this.httpClient.post<TranslationPayload[]>('/offer-data-management/' + rangeId + '/nameAndDescription/translations',  reference);
  }

  exportOptionsOfRange(rangeId: string): Observable<any> {
    return this.httpClient.post('/options/export/'+ rangeId, '',{responseType: 'blob', observe: 'response'});
  }

  editOptionsOrder(rangeId: string, reference: string,optionName: string, currentIndex: number) {
    return this.httpClient.put<any>('/options/order/' + rangeId + '/' + optionName + '/' + currentIndex, reference);
  }

  editOptionValueOrder(optionId: string, optionValueName: string, currentIndex: number) {
    return this.httpClient.put<any>('/options/order/value/' + optionId + '/' + optionValueName + '/' + currentIndex, {});
  }

  addAssociatedOptions(payload: AssociateOptionPayload): Observable<GetOptionsPayload> {
    return this.httpClient.post<GetOptionsPayload>('/options/associate', payload);
  }

  editAssociatedOptions(payload: AssociateOptionCategoryPayload): Observable<GetOptionsPayload> {
    return this.httpClient.put<GetOptionsPayload>('/options/associate', payload);
  }

  previewAssociatedOptions(payload: AssociateOptionPayload):Observable<SwitchBoardComponent[]> {
    return this.httpClient.post<SwitchBoardComponent[]>('/options/beforeAssociate', payload);
  }

  updateCategoryOrder(payload: CategoryOrderUpdatePayload) {
    return this.httpClient.put<void>('/options/category/order', payload);
  }

  updateOptionsOrder(payload: OptionOrderUpdatePayload) {
    return this.httpClient.put<void>('/options/order', payload);
  }
}
